import React from 'react'
import { CircularProgress } from '@mui/material'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import { Directions } from '@mui/icons-material'

function GrivanceTabularList({grievanceList,getMasterLabel,grievanceStats}) {

    const getRowColor = (grievanceStatus) =>{
        let colorClass = "";
        switch(grievanceStatus){
            case 1:
                colorClass = "table-primary";
                break;
            case 2:
                colorClass = "table-warning";
                break;
            case 3:
                colorClass = "table-success";
                break;
            case 4:
                colorClass = "table-danger";
                break;
            case 5:
                colorClass = "table-info";
                break;
            case 6:
                colorClass = "table-light";
                break;
        }
        return colorClass;
    }

  	return (
    	<div className='row'>
            {!grievanceList &&
                <div className='col-md-12 text-center'>
                    <CircularProgress/>
                </div>
            }
            {grievanceList &&
                <>
                <div className='col-md-9'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Grievance Id</th>
                                <th>Complainant Name</th>
                                <th>Complainant Phone</th>
                                <th>About</th>
                                <th>Details</th>
                                <th>Date</th>
                                <th></th>
                                <th>Status</th>
                                <th>Ward No</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {grievanceList && grievanceList.map(grievance=>
                                <tr className={getRowColor(grievance.grievanceStatus)} cl key={grievance.id}>
                                    <td> <Link to={"/grievance/details/"+grievance.id} > {grievance.id} </Link></td>
                                    <td>{grievance.complainantName}</td>
                                    <td>{grievance.phone}</td>
                                    <td>{getMasterLabel('grievance-type',grievance.grievanceType)}</td>
                                    <td>{grievance.details}</td>
                                    <td>{moment(grievance.created_at).format("LLL")}</td>
                                    <td>{moment(grievance.created_at).fromNow()}</td>
                                    <td>{getMasterLabel('grievance-status',grievance.grievanceStatus)}</td>
                                    <td>{grievance.wardNo}</td>
                                    <td><a target='_blank' href={"https://www.google.com/maps/dir//"+grievance.latitude+", "+grievance.longitude} ><Directions/></a></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                
                <div className='col-md-3'>
                    
                        <table className='table'>
                            <tbody>
                                <tr className='table-primary'>
                                    <th>Open</th>
                                    <td>{grievanceStats.progress.pending}</td>
                                </tr>
                                <tr className='table-warning'>
                                    <th>In Progress</th>
                                    <td>{grievanceStats.progress.inProgress}</td>
                                </tr>
                                <tr className='table-success'>
                                    <th>Closed</th>
                                    <td>{grievanceStats.progress.closed}</td>
                                </tr>
                                <tr className='table-danger'>
                                    <th>Reopen</th>
                                    <td>{grievanceStats.progress.reopen}</td>
                                </tr>
                                <tr className='table-info'>
                                    <th>Self Canceled</th>
                                    <td>{grievanceStats.progress.selfCanceled}</td>
                                </tr>
                                <tr className='table-light'>
                                    <th>On Hold</th>
                                    <td>{grievanceStats.progress.onhold}</td>
                                </tr>
                                <tr className='table-dark'>
                                    <th>Total</th>
                                    <td>{grievanceStats.progress.total}</td>
                                </tr>
                            </tbody> 
                        </table>
                    
                    
                        <table className='table'>
                            <tbody>
                                {grievanceStats.grievanceTypeList.map(gt=>
                                    gt.count > 0 &&
                                    <tr key={gt.value}>
                                        <th>{gt.label}</th>
                                        <td>{gt.count}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    
                </div>
                </>
            }
        </div>
  	)
}

export default GrivanceTabularList